// AppRoutes.jsx
import React from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";

import ErrorBoundary from "./ErrorBoundary";
import Header from "./Header/header";
import LoginForm from "./Screens/Login";
import RequireAuth from "./requireAuth";
import LeadsManager from "./Screens/LeadsManager";

const AppRoutes = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const navigate = useNavigate();

  const handleLoginSuccess = (data) => {
    // localStorage.setItem("crm_jwt_token", data.token);
    // localStorage.setItem("profile_image", data.profile_image);

    // localStorage.setItem("nice_name", data.user_display_name);

    // Optionally store to global state here
    //window.location.href = "/"; // or navigate('/')
    navigate("/", { replace: true });
  };

  const handleLogout = () => {
    localStorage.removeItem("crm_jwt_token");
    localStorage.removeItem("nice_name");
    localStorage.removeItem("profile_image");
    sessionStorage.removeItem("crm_jwt_token");

    // Redirect to login page
    navigate("/", { replace: true });
  };
  return (
    <Box sx={{ display: "flex" }}>
      {!isLoginPage && <Header OnLogout={handleLogout} />}
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 5 }}>
        <Toolbar />
        <ErrorBoundary>
          <Routes>
            <Route
              path="/login"
              element={<LoginForm onLogin={handleLoginSuccess} />}
            />

            <Route
              path="/"
              element={
                <RequireAuth>
                  <LeadsManager />
                </RequireAuth>
              }
            />
          </Routes>
        </ErrorBoundary>
      </Box>
    </Box>
  );
};

export default AppRoutes;
